import { render, staticRenderFns } from "./projectScoringComByEx.vue?vue&type=template&id=4c161962"
import script from "./projectScoringComByEx.vue?vue&type=script&lang=js"
export * from "./projectScoringComByEx.vue?vue&type=script&lang=js"
import style0 from "./projectScoringComByEx.vue?vue&type=style&index=0&id=4c161962&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports